export function LinkButton(props: {
  label: string;
  link: string;
  color?: string;
  backgroundColor?: string;
}) {
  return (
    <div
      className="tw:flex tw:items-center tw:justify-center tw:min-w-full! tw:w-full! tw:rounded-xl tw:p-3"
      style={{ backgroundColor: props.backgroundColor ?? undefined }}
    >
      <a href={props.link}>
        <div
          className="tw:text-md"
          style={{
            color: props.color ?? undefined,
          }}
        >
          {props.label}
        </div>
      </a>
    </div>
  );
}
